var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","height":"94.7vh"}},[_c('span',{staticClass:"return",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("<<返回")]),_vm._v(" "),_c('iframe',{attrs:{"src":"http://local.vrmaker.vip:38080/web-bim/gis.html","frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b0c25e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gis.vue
// module id = null
// module chunks = 